/**
 * Makes sure a value is defined and let typescript infer the defined type.
 *
 * Values such as 0, '' and false count as "defined"
 */
const isNotNull = <T>(value: T): value is Exclude<T, null | undefined> => value !== null && value !== undefined;

export default isNotNull;
